// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 100 ? "forgot-password" : chunkId) + "." + {"68":"5f6de206","100":"ce42748e"}[chunkId] + ".js";
};